import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Avatar, Badge, Card, Col, Row, Tooltip, Typography } from 'antd'
import { Icon } from '@iconify/react'

import { getRandomAvatar } from '../../../assets/clients/avatar'
import {
    getDisplayName,
    getInitials,
} from '../talent.utils'
import TalentPhoneValue from './TalentPhoneValue'
import styles from './TalentList.module.css'

const { Text } = Typography

const TalentList = ({
    users = [],
    loading = false,
    loadingMore = false,
    isNext = false,
    onLoadMore,
    onManagePermissions,
    canEdit = true,
}) => {
    if (loading && !users.length) {
        return (
            <div className={styles.talentListContainer}>
                <div className={styles.loadingContainer}>
                    <Icon
                        icon="line-md:loading-loop"
                        style={{ fontSize: 48, color: '#6366f1' }}
                    />
                </div>
            </div>
        )
    }

    if (!loading && !users.length) {
        return (
            <div className={styles.talentListContainer}>
                <div className={styles.emptyState}>
                    <Icon
                        icon="mdi:account-group-outline"
                        style={{ fontSize: 48 }}
                    />
                    <div>No talent users found.</div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.talentListContainer}>
            <InfiniteScroll
                dataLength={users.length}
                next={onLoadMore}
                hasMore={isNext}
                initialLoad={false}
                scrollThreshold="200px"
                loader={
                    loadingMore ? (
                        <div className={styles.loadingContainer}>
                            <Icon
                                icon="line-md:loading-loop"
                                style={{ fontSize: 26, color: '#6366f1' }}
                            />
                        </div>
                    ) : null
                }
                scrollableTarget="talent-scroll-container"
            >
                <Row gutter={[20, 20]} style={{ paddingTop: 5 }}>
                    {users.map((user) => {
                        const avatarSrc =
                            user?.profilePicture ||
                            getRandomAvatar({
                                seed:
                                    user?._id || user?.email || user?.name,
                            })
                        const isArchived = Boolean(user?.isDeleted)

                        return (
                            <Col key={user?._id || user?.id} xs={24} sm={12} lg={8} xl={6}>
                                <Badge.Ribbon
                                    text="Archived"
                                    color="#adadad"
                                    className={styles.talentArchivedRibbon}
                                    style={{
                                        display: isArchived
                                            ? 'inline-block'
                                            : 'none',
                                    }}
                                >
                                    <Card
                                        className={styles.talentCard}
                                        hoverable={false}
                                    >
                                        <div className={styles.cardContent}>
                                            <div className={styles.cardHeader}>
                                                <Avatar
                                                    size={44}
                                                    className={styles.talentAvatar}
                                                    src={avatarSrc}
                                                >
                                                    {!avatarSrc
                                                        ? getInitials(user)
                                                        : null}
                                                </Avatar>
                                                <div className={styles.talentInfo}>
                                                    <Text
                                                        className={
                                                            styles.talentName
                                                        }
                                                    >
                                                        {getDisplayName(user)}
                                                    </Text>
                                                    <Text
                                                        className={
                                                            styles.talentEmail
                                                        }
                                                    >
                                                        {user?.email || 'N/A'}
                                                    </Text>
                                                </div>
                                                <div
                                                    className={
                                                        styles.talentActions
                                                    }
                                                >
                                                    {canEdit ? (
                                                        <Tooltip title="Permissions">
                                                            <button
                                                                type="button"
                                                                className={
                                                                    styles.actionIconBtn
                                                                }
                                                                onClick={() =>
                                                                    onManagePermissions?.(
                                                                        user
                                                                    )
                                                                }
                                                            >
                                                                <Icon
                                                                    icon="mdi:shield-account-outline"
                                                                    width={18}
                                                                    height={18}
                                                                />
                                                            </button>
                                                        </Tooltip>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div
                                                className={
                                                    styles.detailsSection
                                                }
                                            >
                                                <div
                                                    className={styles.phoneBlock}
                                                >
                                                    <div
                                                        className={
                                                            styles.phoneHeader
                                                        }
                                                    >
                                                        <Icon
                                                            icon="mdi:phone-outline"
                                                            className={
                                                                styles.phoneIcon
                                                            }
                                                        />
                                                        <span
                                                            className={
                                                                styles.phoneLabel
                                                            }
                                                        >
                                                            Phone
                                                        </span>
                                                    </div>
                                                    <TalentPhoneValue
                                                        record={user}
                                                        className={`${styles.phoneValue} ${
                                                            !user?.phone
                                                                ? styles.phoneMuted
                                                                : ''
                                                        }`}
                                                    />
                                                </div>
                                                <span
                                                    className={
                                                        isArchived
                                                            ? styles.statusArchived
                                                            : styles.statusActive
                                                    }
                                                >
                                                    {isArchived
                                                        ? 'Archived'
                                                        : 'Active'}
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                        )
                    })}
                </Row>
            </InfiniteScroll>
        </div>
    )
}

export default TalentList
